/**
 * T1 RWE Stock Alert
 * ---------------------------------------------------------------------------
 * Keeps the buy-box scarcity pill in step with the selected variant.
 *
 * ⚠️ WHY THIS FILE EXISTS AT ALL. Horizon does NOT re-render the product
 * section on a variant change. `assets/variant-picker.js` sets
 * `morphElementSelector = undefined` on a normal PDP, fetches the product URL
 * with no `section_id`, and morphs ONLY the <variant-picker> element. So a
 * server-rendered `inventory_quantity` freezes on the first variant unless the
 * element opts in to `variant:update` and pulls its own node out of the
 * already-fetched document -- which is exactly what every other live-updating
 * block on this theme does. This mirrors `assets/product-inventory.js`.
 *
 * ⚠️ DO NOT move this into an inline <script> in the block. `assets/morph.js`
 * only re-executes `.shopify-app-block script[src]`; nodes come from DOMParser
 * and are flagged "already started", so an inline script never runs again.
 */
import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class T1StockAlert extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStockAlert);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockAlert);
  }

  updateStockAlert = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const next = event.detail.data.html.querySelector('t1-stock-alert');
    if (!next) return;

    // childrenOnly: the pill is emitted server-side only when the variant is
    // genuinely low, so "hide" is simply an empty child list. Root attributes
    // are NOT morphed -- keep every stateful value inside the children.
    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('t1-stock-alert')) {
  customElements.define('t1-stock-alert', T1StockAlert);
}
